import { render } from "./FileUploader.vue?vue&type=template&id=71f6a495&scoped=true&ts=true"
import script from "./FileUploader.vue?vue&type=script&lang=ts"
export * from "./FileUploader.vue?vue&type=script&lang=ts"

import "./FileUploader.vue?vue&type=style&index=0&id=71f6a495&scoped=true&lang=css"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f6a495"]])

export default __exports__